module.exports = __webpack_public_path__ + "img/up.376db9dc.svg";